//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    ifdictEdit: {
      type: Boolean,
      default: false
    },
    AddformData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    editordate: null
  },
  data: function data() {
    return {
      formPower: {
        dictGroupCode: null,
        dictGroupName: null,
        systemId: null
      },
      formPowerdefault: {
        dictGroupCode: null,
        dictGroupName: null,
        systemId: null
      },
      roleRules: {
        dictGroupName: [{
          required: true,
          message: '请输入键值对组名称',
          trigger: 'blur'
        }],
        dictGroupCode: [{
          required: true,
          message: '请输入键值对组键值',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    if (this.ifdictEdit) {
      this.formPower = this.editordate;
    } else {
      this.formPower = this.formPowerdefault;
    }
    // this.formPower = this.AddformData;
  },

  methods: {
    cancelDailog: function cancelDailog() {
      this.$emit('DictgroupAddSubmit', {
        bool: false
      });
    },
    commit: function commit() {
      var _this = this;
      this.$refs.formPower.validate(function (valid) {
        if (valid) {
          _this.$emit('DictgroupAddSubmit', {
            bool: true,
            formData: _this.formPower
          });
        } else {
          _this.$message({
            message: '请完善信息填写',
            type: 'warning'
          });
          return false;
        }
      });
    },
    confirmsure: function confirmsure(bool) {
      if (bool) {
        this.commit();
      }
    }
  }
};